<button
    type="button"
    class="d-flex body-2"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
    style="background-color: white; border: none; color: #0076FF;"
>
    {{title}}                                
</button>

<ng-template #content >
    <div class="popover-links">
        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer pl-3 pr-2" (click)="openLink()">
            <div class="d-flex align-items-center">
                <i class="fas fa-globe p2p-popover-icon d-flex align-items-center cursor--pointer mr-2"></i>
                <span class="body-2 cursor--pointer">Open {{title}}</span>
            </div>
        </div>
        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer pl-3 pr-2" (click)="copyLink()">
            <div class="d-flex align-items-center">
                <i class="far fa-copy p2p-popover-icon d-flex align-items-center mr-2"></i>    
                <span class="body-2 cursor--pointer">Copy {{title}}</span>
            </div>
        </div>
        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer pl-3 pr-2" (click)="downloadQrCode()">
            <div class="d-flex align-items-center">
                <i class="fas fa-download p2p-popover-icon d-flex align-items-center mr-2"></i>
                <span class="body-2 cursor--pointer">Download Qr Code</span>
            </div>
        </div>
    </div>
</ng-template>
